import Repository from "./Repository";

const schools = "/schools";

export default {
  getSchools: (params) => Repository.get(`${schools}/`, { params: params }),
  getSchool: (id) => Repository.get(`${schools}/${id}/`),
  updateSchool: (payload) =>
    Repository.patch(`${schools}/${payload.id}/`, payload),
  createSchool: (payload) => Repository.post(`${schools}/`, payload),
  retrieveSchoolClasses: (id) =>
    Repository.get(`${schools}/${id}/retrieve_classes/`),
  purgeSchools: (payload) => Repository.put(`${schools}/purge/`, payload),
};
